// Gemstone Minerals - Mock Data
// Products sourced from GemstoneMinerals.com with enhanced spiritual properties

export const products = [
  {
    id: 1,
    name: "Amethyst 2lbs 4oz",
    slug: "amethyst-2lbs",
    category: "Amethyst",
    price: 275.00,
    originalPrice: null,
    image: "https://images.pexels.com/photos/2942855/pexels-photo-2942855.jpeg?auto=compress&cs=tinysrgb&w=600",
    images: [
      "https://images.pexels.com/photos/2942855/pexels-photo-2942855.jpeg?auto=compress&cs=tinysrgb&w=600",
      "https://images.unsplash.com/photo-1626470408813-f0059745d58b?w=600&q=80"
    ],
    inStock: true,
    featured: true,
    weight: "2lbs 4oz",
    chakra: "Crown",
    chakraColor: "#9D4EDD",
    healingProperties: ["Spiritual Growth", "Intuition", "Calming", "Protection"],
    zodiac: ["Pisces", "Virgo", "Aquarius"],
    element: "Air",
    description: "This majestic Amethyst specimen radiates powerful crown chakra energy. Known as the 'Stone of Spiritual Wisdom', this crystal has been prized for centuries by healers, mystics, and royalty alike. Its deep purple hues connect you to higher consciousness and divine guidance.",
    shortDescription: "Powerful crown chakra crystal for spiritual awakening and divine connection."
  },
  {
    id: 2,
    name: "Black Tourmaline Crystal 4oz",
    slug: "black-tourmaline",
    category: "Black Tourmaline",
    price: 150.00,
    originalPrice: null,
    image: "https://images.unsplash.com/photo-1603956418402-694d244194ad?w=600&q=80",
    images: [
      "https://images.unsplash.com/photo-1603956418402-694d244194ad?w=600&q=80"
    ],
    inStock: false,
    featured: true,
    weight: "4oz",
    chakra: "Root",
    chakraColor: "#FF6B6B",
    healingProperties: ["Protection", "Grounding", "EMF Shield", "Negativity Cleanse"],
    zodiac: ["Capricorn", "Libra"],
    element: "Earth",
    description: "The ultimate protection stone. Black Tourmaline creates an energetic shield around your aura, deflecting negative energies and psychic attacks. Essential for empaths and energy workers.",
    shortDescription: "Master protector stone - shields against negative energies and EMF."
  },
  {
    id: 3,
    name: "Rose Quartz Crystal Tower",
    slug: "rose-quartz-tower",
    category: "Rose Quartz",
    price: 420.00,
    originalPrice: 500.00,
    image: "https://images.unsplash.com/photo-1584714553016-ab06df492eba?w=600&q=80",
    images: [
      "https://images.unsplash.com/photo-1584714553016-ab06df492eba?w=600&q=80",
      "https://images.unsplash.com/photo-1728234553997-f71b87a44e13?w=600&q=80"
    ],
    inStock: true,
    featured: true,
    weight: "Large Tower",
    chakra: "Heart",
    chakraColor: "#00C853",
    healingProperties: ["Unconditional Love", "Self-Love", "Emotional Healing", "Compassion"],
    zodiac: ["Taurus", "Libra"],
    element: "Water",
    description: "The stone of universal love. This exquisite Rose Quartz tower emanates gentle, nurturing energy that opens the heart to all forms of love. Perfect for attracting romance, deepening relationships, and cultivating self-love.",
    shortDescription: "Heart chakra crystal tower radiating unconditional love energy.",
    discount: 16
  },
  {
    id: 4,
    name: "Selenite Large Crystal",
    slug: "selenite-large",
    category: "Selenite",
    price: 360.00,
    originalPrice: null,
    image: "https://images.pexels.com/photos/4040582/pexels-photo-4040582.jpeg?auto=compress&cs=tinysrgb&w=600",
    images: [
      "https://images.pexels.com/photos/4040582/pexels-photo-4040582.jpeg?auto=compress&cs=tinysrgb&w=600"
    ],
    inStock: true,
    featured: true,
    weight: "Large",
    chakra: "Crown",
    chakraColor: "#9D4EDD",
    healingProperties: ["Cleansing", "Clarity", "Angelic Connection", "Peace"],
    zodiac: ["Cancer", "Taurus"],
    element: "Air",
    description: "Named after Selene, the Greek goddess of the moon, this luminous crystal carries ethereal energy that cleanses and charges other crystals. Its high vibration connects you to angelic realms and brings mental clarity.",
    shortDescription: "Luminous moon crystal for cleansing, clarity, and angelic guidance."
  },
  {
    id: 5,
    name: "Selenite Candle Holders",
    slug: "selenite-candle-holders",
    category: "Selenite",
    price: 50.00,
    originalPrice: 60.00,
    image: "https://images.pexels.com/photos/4040587/pexels-photo-4040587.jpeg?auto=compress&cs=tinysrgb&w=600",
    images: [
      "https://images.pexels.com/photos/4040587/pexels-photo-4040587.jpeg?auto=compress&cs=tinysrgb&w=600"
    ],
    inStock: true,
    featured: false,
    weight: "Set of 2",
    chakra: "Crown",
    chakraColor: "#9D4EDD",
    healingProperties: ["Cleansing", "Ambiance", "Peace", "Meditation"],
    zodiac: ["Cancer", "Taurus"],
    element: "Air",
    description: "Transform your sacred space with these enchanting Selenite candle holders. When lit, they create a magical glow that enhances meditation, rituals, and spiritual practices.",
    shortDescription: "Ethereal candle holders for sacred space ambiance.",
    discount: 17
  },
  {
    id: 6,
    name: "Selenite Round Bowl w/ Rose Quartz",
    slug: "selenite-bowl-rose-quartz",
    category: "Selenite",
    price: 150.00,
    originalPrice: null,
    image: "https://images.pexels.com/photos/4040588/pexels-photo-4040588.jpeg?auto=compress&cs=tinysrgb&w=600",
    images: [
      "https://images.pexels.com/photos/4040588/pexels-photo-4040588.jpeg?auto=compress&cs=tinysrgb&w=600"
    ],
    inStock: true,
    featured: false,
    weight: "Medium Bowl",
    chakra: "Crown & Heart",
    chakraColor: "#9D4EDD",
    healingProperties: ["Cleansing", "Love", "Charging Station", "Harmony"],
    zodiac: ["Cancer", "Taurus", "Libra"],
    element: "Air & Water",
    description: "A divine pairing of Selenite and Rose Quartz. Use this beautiful bowl to cleanse and charge your jewelry and smaller crystals while infusing them with loving energy.",
    shortDescription: "Crystal charging bowl combining cleansing and love energies."
  },
  {
    id: 7,
    name: "Selenite Small Bowl",
    slug: "selenite-small-bowl",
    category: "Selenite",
    price: 65.00,
    originalPrice: null,
    image: "https://images.pexels.com/photos/4040589/pexels-photo-4040589.jpeg?auto=compress&cs=tinysrgb&w=600",
    images: [
      "https://images.pexels.com/photos/4040589/pexels-photo-4040589.jpeg?auto=compress&cs=tinysrgb&w=600"
    ],
    inStock: true,
    featured: false,
    weight: "Small",
    chakra: "Crown",
    chakraColor: "#9D4EDD",
    healingProperties: ["Cleansing", "Charging", "Peace"],
    zodiac: ["Cancer", "Taurus"],
    element: "Air",
    description: "Perfect for cleansing and charging your crystal jewelry and tumbled stones. This Selenite bowl radiates pure, high-vibrational energy.",
    shortDescription: "Compact crystal charging and cleansing bowl."
  },
  {
    id: 8,
    name: "Selenite Tower",
    slug: "selenite-tower",
    category: "Selenite",
    price: 120.00,
    originalPrice: null,
    image: "https://images.pexels.com/photos/4040591/pexels-photo-4040591.jpeg?auto=compress&cs=tinysrgb&w=600",
    images: [
      "https://images.pexels.com/photos/4040591/pexels-photo-4040591.jpeg?auto=compress&cs=tinysrgb&w=600"
    ],
    inStock: true,
    featured: false,
    weight: "Tower",
    chakra: "Crown",
    chakraColor: "#9D4EDD",
    healingProperties: ["Energy Amplification", "Clarity", "Space Cleansing"],
    zodiac: ["Cancer", "Taurus"],
    element: "Air",
    description: "This elegant Selenite tower acts as an energy beacon, radiating cleansing vibrations throughout your space. Perfect for altars and meditation corners.",
    shortDescription: "Elegant energy beacon for space purification."
  },
  {
    id: 9,
    name: "Sun-Kissed Amethyst Cluster",
    slug: "sun-kissed-amethyst",
    category: "Amethyst",
    price: 200.00,
    originalPrice: null,
    image: "https://images.unsplash.com/photo-1634138235644-c78b81c0d8c0?w=600&q=80",
    images: [
      "https://images.unsplash.com/photo-1634138235644-c78b81c0d8c0?w=600&q=80"
    ],
    inStock: true,
    featured: false,
    weight: "Cluster",
    chakra: "Crown & Third Eye",
    chakraColor: "#9D4EDD",
    healingProperties: ["Spiritual Growth", "Intuition", "Dreams", "Meditation"],
    zodiac: ["Pisces", "Virgo", "Aquarius"],
    element: "Air",
    description: "This rare sun-kissed Amethyst cluster features natural golden inclusions that amplify its spiritual properties. A stunning centerpiece for any crystal collection.",
    shortDescription: "Rare golden-tinged Amethyst for enhanced spiritual connection."
  },
  {
    id: 10,
    name: "Smokey Quartz Healing Wand",
    slug: "smokey-quartz-wand",
    category: "Smokey Quartz",
    price: 150.00,
    originalPrice: null,
    image: "https://images.pexels.com/photos/4040593/pexels-photo-4040593.jpeg?auto=compress&cs=tinysrgb&w=600",
    images: [
      "https://images.pexels.com/photos/4040593/pexels-photo-4040593.jpeg?auto=compress&cs=tinysrgb&w=600"
    ],
    inStock: true,
    featured: false,
    weight: "Wand",
    chakra: "Root",
    chakraColor: "#FF6B6B",
    healingProperties: ["Grounding", "Transmutation", "Protection", "Stress Relief"],
    zodiac: ["Scorpio", "Sagittarius", "Capricorn"],
    element: "Earth",
    description: "A powerful healing tool for energy practitioners. This Smokey Quartz wand transmutes negative energy into positive, grounding vibrations. Essential for shadow work and energy clearing.",
    shortDescription: "Energy healer's tool for transmutation and grounding."
  }
];

export const categories = [
  { id: 1, name: "Amethyst", slug: "amethyst", count: 2, color: "#9D4EDD" },
  { id: 2, name: "Black Tourmaline", slug: "black-tourmaline", count: 1, color: "#2D3436" },
  { id: 3, name: "Rose Quartz", slug: "rose-quartz", count: 1, color: "#FF6B9D" },
  { id: 4, name: "Selenite", slug: "selenite", count: 5, color: "#DFE6E9" },
  { id: 5, name: "Smokey Quartz", slug: "smokey-quartz", count: 1, color: "#636E72" }
];

export const chakras = [
  { name: "Root", color: "#FF6B6B", description: "Grounding & Security" },
  { name: "Sacral", color: "#FF9F43", description: "Creativity & Passion" },
  { name: "Solar Plexus", color: "#FFB800", description: "Power & Confidence" },
  { name: "Heart", color: "#00C853", description: "Love & Compassion" },
  { name: "Throat", color: "#00B4D8", description: "Communication & Truth" },
  { name: "Third Eye", color: "#9D4EDD", description: "Intuition & Wisdom" },
  { name: "Crown", color: "#C77DFF", description: "Spirituality & Enlightenment" }
];

export const healingCategories = [
  { name: "Protection", icon: "Shield" },
  { name: "Love", icon: "Heart" },
  { name: "Grounding", icon: "Mountain" },
  { name: "Spiritual Growth", icon: "Sparkles" },
  { name: "Cleansing", icon: "Droplets" },
  { name: "Intuition", icon: "Eye" },
  { name: "Calming", icon: "Moon" },
  { name: "Clarity", icon: "Sun" }
];

export const testimonials = [
  {
    id: 1,
    name: "Lisa T.",
    text: "We ordered a few stones from here and couldn't be more happier. They have very nice pieces. The energy is good.",
    rating: 5,
    location: "California"
  },
  {
    id: 2,
    name: "Sarah M.",
    text: "The Selenite tower I received is absolutely stunning. I can feel its cleansing energy radiating throughout my entire home. Truly transformative!",
    rating: 5,
    location: "New York"
  },
  {
    id: 3,
    name: "Crystal Healer Diana",
    text: "As a professional energy healer, I'm very particular about my crystals. Gemstone Minerals consistently provides the highest quality specimens I've found.",
    rating: 5,
    location: "Arizona"
  }
];

export const siteInfo = {
  name: "Gemstone Minerals",
  tagline: "Gemstone Healing Redefined",
  subTagline: "Embark on a Transformative Journey with Crystals",
  phone: "+1 (424) 450-7018",
  email: "info@gemstoneminerals.com",
  features: [
    { title: "2025 Discount", description: "16% Discount on Rose Quartz", icon: "Percent" },
    { title: "National Shipping", description: "We ship via FedEx, UPS and Priority Mail", icon: "Truck" },
    { title: "Risk Free Shopping", description: "7 day return/exchange policy", icon: "ShieldCheck" }
  ]
};
